NtechApp.MessagesList = function($view, chatMessagesForm, chatControls, chatMembers) {
    var me = this;

    this._$view = null;
    this._autolinker = null;

    this._chatMessagesForm = null;
    this._chatControls = null;
    this._chatMembers = null;

    this._ajax = null;
    this._click = null;

    this._loader = null;
    this._overlay = null;

    this._lastAjaxRequest = -1;
    this._areMessagesLoading = false;

    this._construct = function() {
        me._$view = $view;
        me._autolinker = new Autolinker({className: "messageLink"});

        me._chatMessagesForm = chatMessagesForm;
        me._chatControls = chatControls;
        me._chatMembers = chatMembers;

        me._ajax = new NtechApp.Ajax();
        me._click = new NtechApp.TouchClickEvent();

        me._loader = new NtechApp.Loader(
            35, 35, "absolute", this._$view.closest(".content")
        );
        me._overlay = new NtechApp.Overlay(
            this._$view.closest(".content"),
            {position: "absolute"}
        );

        //me.selectChatListItem(me._selectedChatId);
        me._scrollChatToBottom();

        NtechApp.lockScroll(me._$view.find("[data-scrollableContent]"));

        me._bindEvents();
        me._bindAjaxPollingUpdates();
    }

    this._bindEvents = function() {
        me._click.listen(me._$view, "[data-loadNextOldestMessageId]", function(event) {
            var $item = $(event.target).closest("[data-loadNextOldestMessageId]");

            if($item.hasClass("lockLoadNextButton"))
                return;

            $item.addClass("lockLoadNextButton");
            me._loadPrevMessages($item);
        });
    }

    this._bindAjaxPollingUpdates = function() {
        NtechApp.ajaxPolling.addPullRequestParamsResolver(function() {
            // @todo -> Sync fetch speed here(If should pull -> chat opened -> pull faster))
            if(!me._chatMessagesForm.shouldPullNewChatMessages() || me._areMessagesLoading)
                return {};

            var $lastMessagesByNotViewer = me._$view.find("[data-isCreatedByViewer='0']");
            if($lastMessagesByNotViewer.length > 0)
                var lastMessageByNotViewerId = $lastMessagesByNotViewer.last().attr("data-messageModel");
            else {
                var lastMessageByNotViewerId = null;
            }

            var $lastMessagesByViewer = me._$view.find("[data-isCreatedByViewer='1']");
            if($lastMessagesByViewer.length > 0)
                var lastMessageByViewerId = $lastMessagesByViewer.last().attr("data-messageModel");
            else
                var lastMessageByViewerId = null;

            var chatId = me._chatMessagesForm.getOpenedChatId();

            var params = {};
            params["pullChatMessagesChatId"] = chatId;
            params["pullChatMessagesLastId"] = lastMessageByNotViewerId;
            params["pullViewerChatMessagesLastId"] = lastMessageByViewerId;

            return params;
        });

        $(NtechApp.ajaxPolling).on(NtechApp.AjaxPolling.EVENT_ON_DATA_PULL, function(e, data) {
            if(!data.wasChatMessagesUpdates && !data.wasViewerChatMessagesUpdates)
                return;

            if(data.wasViewerChatMessagesUpdates)
                me._$view.find(".chatListGrid .columnContentWrapper").append(data.viewerNewChatMessagesHtml);

            if(data.wasChatMessagesUpdates)
                me._$view.find(".chatListGrid .columnContentWrapper").append(data.newChatMessagesHtml);

            me._processMessageTexts();
            me._scrollChatToBottom();

            var data = data.chatMessagesLastMessageData;
            me._chatMessagesForm.emitOnNewMessageCreateEvent();
            me._chatMessagesForm.emitOnNewMessageSaveEvent(data.chatId, data.message, data.messageDate);

            me.removeMessageDuplicates();
        });
    }

    this._unbindEvents = function() {
        ;
    }

    this.destruct = function() {
        me._unbindEvents();
    }

    this._construct();
    return this;
};

NtechApp.MessagesList.EVENT_CHAT_MESSAGES_VIEWED = "NtechApp.MessagesList.EventChatMessagesViewed";

NtechApp.proto(NtechApp.MessagesList, {
    _getLoadMessagesRoute: function() {
        if(NtechApp.clientSettings.isPersonal)
            return 'personal_load_chat_messages_page';
        else if(NtechApp.clientSettings.isBusiness)
            return 'business_load_chat_messages_page';
    },

    _scrollChatToBottom: function() {
        var $view = this._$view.find(".scrollableContent");
        $view.scrollTop($view[0].scrollHeight);
    },

    _scrollChatToItem: function($item, extraOffset) {
        var $view = this._$view.find(".scrollableContent");
        var extraOffset = extraOffset || 0;

        $view.scrollTop($item.position().top - extraOffset);
    },

    _loadPrevMessages: function($item) {
        var me = this;
        var oldestMessageId = $item.attr("data-loadNextOldestMessageId");

        me._ajax.enableTextLoading($item);

        var params = {
            oldestMessageId: oldestMessageId || null,
            chatId: this._chatMessagesForm.getOpenedChatId()
        };

        me._ajax.get({
            url: Routing.generate(me._getLoadMessagesRoute(), params),
            onSuccess: function(data) {
                var loadPrevHeight = $item.outerHeight();
                var $firstItem = me._$view.find("[data-messageModel]").first();

                $item.remove();

                $firstItem.parent().prepend(
                    $($.parseHTML(data.html))
                );
                me._scrollChatToItem($firstItem, loadPrevHeight);

                me._processMessageTexts();
            },
            onComplete: function() {
                //if(me._nextLoadRequestData == null)
                //    me._loaderOff();
            }
        });
    },

    _loaderOn: function() {
        this._loader.on();
        this._overlay.on();

        this._chatControls.lockControls();
    },

    _loaderOff: function() {
        this._loader.off();
        this._overlay.off();

        this._chatControls.unlockControls();
    },

    loaderOn: function() { this._loaderOn(); },
    loaderOff: function() { this._loaderOff(); },

    _clearCurrentChatMessages: function() {
        this._$view.find("[data-messageModel]").remove();
        this._$view.find(".loadMoreResults").remove();
    },

    loadChatMessages: function(chatId) {
        var me = this;
        var params = {
            nextPage: 0,
            chatId: chatId,
            requestNumber: ++this._lastAjaxRequest
        };

        me._areMessagesLoading = true;
        me._loaderOn();

        me._ajax.get({
            url: Routing.generate(me._getLoadMessagesRoute(), params),
            onSuccess: function(data) {
                if(data.requestNumber != me._lastAjaxRequest)
                    return;

                me._loaderOff();
                me._clearCurrentChatMessages();

                me._$view.find(".chatListGrid .columnContentWrapper").append(
                    $($.parseHTML(data.html))
                );

                me._chatMembers.updateLabel(
                    data.selectedChatName, data.selectedShortChatName, data.selectedChatMembers
                );

                me._processMessageTexts();
                me._scrollChatToBottom();
                me._areMessagesLoading = false;

                if(data.wereMessagesViewed) {
                    $(window).trigger(
                        NtechApp.WINDOW_EVENTS.EVENT_CHAT_MESSAGES_VIEWED,
                        [chatId]
                    );
                }
            },
            onComplete: function() {
                //if(me._nextLoadRequestData == null)
                //    me._loaderOff();
            }
        });
    },

    _processMessageTexts: function() {
        var me = this;

        NtechApp.dateTools.convertDates(me._$view);
        $.each(me._$view.find("[data-messageText]"), function() {
            var $linkedHtml = me._autolinker.link($(this).html());
            $(this).html($linkedHtml);
        });
    },

    escapeMessage: function(message) {
        var messageText = message.substr(0);
        return messageText.replace(/(?:\r\n|\r|\n)/g, '<br />');
    },

    insertMessage: function($message) {
        this._$view.find(".chatListGrid .columnContentWrapper").append($message);

        this._processMessageTexts();
        this._scrollChatToBottom();
    },

    // Viewer new message could be pulled in the same time
    // it is saving in database.(It will be marked with data-messageModel
    // only after save end, so we really should remove newest message duplicates)
    removeMessageDuplicates: function() {
        var me = this;
        var messages = me._$view.find("[data-messageModel]").toArray();

        var rmIndexes = [];
        for(var i = 0; i < messages.length; i++) {
            var $checkedMessage = $(messages[i]);

            for(var j = i + 1; j < messages.length; j++) {
                var $nextMessage = $(messages[j]);
                if($checkedMessage.attr("data-messageModel") == $nextMessage.attr("data-messageModel"))
                    rmIndexes.push(j);
            }
        }

        var messagesToRemove = [];
        for(var i = 0; i < rmIndexes.length; i++)
            messagesToRemove.push(messages[rmIndexes[i]]);

        for(var i = 0; i < messagesToRemove.length; i++)
            $(messagesToRemove[i]).remove();
    }
});